import { Modal, notification, Table } from 'antd';
import { localize } from 'mixins/helpers';
import { BaseMetaDocument, CustomColumn } from 'mixins/types';
import Button from 'mixins/ui/button/button';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { IPollData } from '../../express-help/express-help.types';
import { downloadDocumentIndex, saveFile, searchIndex } from '../actions';
import { IExternalTradeDocument } from '../stats-external-client.types';
import { SearchExternal } from './search/search';
import { TypeEnum } from './search/search.data';

const ClientIndexComponent: FC = (props: any) => {
    const [isLoading, setIsLoading] = useState(false);
    const [downloadingFileIndex, setDownloadingFileIndex] = useState<number>();
    const [data, setData] = useState<IPollData[]>([]);
    const [formValue, setFormValue] = useState<Record<string, any>>([]);
    const [hasSearched, setHasSearched] = useState(false);

    const pageSize = 20;
    const [pageNumber, setPageNumber] = useState(1);
    const [total, setTotal] = useState(0);

    const { confirm } = Modal;

    const getIndexFormParams = (values: Record<string, any>): Record<string, any> => {
        if (values) {
            if (values.region) {
                values.areaCode = values.region;
                values.region = undefined;
            }

            if (values.type) {
                if ((values.type === 'TS' && values.areaCode === '01') || values.type !== 'TS') {
                    if (values.type === 'SVT' && values.period === 2) {
                        values.reportCode = TypeEnum.SVT_G;
                    } else {
                        values.reportCode = values.type.toUpperCase();
                    }
                }

                values.type = undefined;
            }

            switch (values.period) {
                case 0:
                    values.period = 'allM';
                    break;
                case 1:
                    values.period = 'allQ';
                    break;
                case 2:
                    values.period = 'allY';
                    break;
                case 0:
                    values.period = 'allM';
                    break;
                case 1:
                    values.period = 'allQ';
                    break;
                case 2:
                    values.period = 'allY';
                    break;
            }

            if (values.year && typeof values.year !== 'string') {
                values.year = values.year.year().toString().slice(-2);

                if (!values.month && !values.quarter && !['allM', 'allQ'].includes(values.period)) {
                    values.period = undefined;
                }
            }

            if (values.month) {
                values.period = getMonth(values.month);
                values.month = undefined;
            }

            if (values.quarter) {
                values.period = values.quarter;
                values.quarter = undefined;
            }
        }

        return values;
    };

    const getMonth = (month: number) => {
        if (month < 10) {
            return `0${month}`;
        }

        return month;
    };

    const columns = useMemo(() => {
        return [
            {
                title: '№',
                width: 100,
                render: (text, record, i) => i + 1 + (pageNumber - 1) * pageSize,
            },
            {
                title: localize('stats-external-name-document', props.translations),
                dataIndex: 'nameRu',
                key: 'nameRu',
            },
            {
                title: localize('actions', props.translations),
                key: 'actions',
                width: 200,
                render: (text, record, index) => (
                    <span>
                        <Button
                            type="default"
                            onClick={downloadDoc(record.metaDocument, index)}
                            loading={index === downloadingFileIndex}
                        >
                            {localize('button.download', props.translations)}
                        </Button>
                    </span>
                ),
            },
        ] as CustomColumn<IExternalTradeDocument>[];
    }, [downloadingFileIndex, pageNumber]);

    const downloadDoc = (record: BaseMetaDocument, index: number) => {
        return () => {
            confirm({
                title: localize('stats-external-confirm-download', props.translations),
                onOk: async () => {
                    setDownloadingFileIndex(index);
                    // const isVerified = await executeRecaptcha('stats_external_client_download_doc');
                    // if (!isVerified) {
                    //     return;
                    // }

                    downloadDocumentIndex(record.fileUid)
                        .then((value) => {
                            saveFile(value.data, value.headers['content-type'], record.fileName);

                            notification['success']({
                                message: localize(
                                    'stats-external-uploaded-successfully',
                                    props.translations
                                ),
                            });
                        })
                        .finally(() => setDownloadingFileIndex(undefined));
                },
            });
        };
    };

    const getSearchIndex = async () => {
        // const isVerified = await executeRecaptcha('stats_external');

        // if (!isVerified) {
        //     return;
        // }
        setIsLoading(true);

        searchIndex({
            ...getIndexFormParams(formValue),
            page: pageNumber - 1,
            size: pageSize,
        })
            .then((value) => {
                setData(value.data.content);
                setTotal(value.data.totalElements);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (hasSearched) {
            getSearchIndex();
        }
    }, [pageNumber, formValue, hasSearched]);

    const handlePageNumberChange = (value: any) => {
        setPageNumber(value.current);
    };

    const handleSearch = (value?: any) => {
        if (!hasSearched) {
            setHasSearched(true);
        }
        setFormValue(value);
        setPageNumber(1);
    };

    return (
        <div className="stats-external-trade">
            <SearchExternal
                onFinish={handleSearch}
                translations={props.translations}
                lang={props.lang}
            />

            {hasSearched && (
                <Table
                    dataSource={data}
                    columns={columns}
                    loading={isLoading}
                    pagination={{
                        current: pageNumber,
                        pageSize,
                        total,
                        showSizeChanger: false,
                    }}
                    onChange={handlePageNumberChange}
                />
            )}
        </div>
    );
};

export default ClientIndexComponent;
